const Client = {
  hasCatalogAccess: function (client) {
    if (!client) return false;

    const tags = client.tags || [];
    
    return tags.indexOf('acesso-catalogos') !== -1 || tags.indexOf('catalogo-corp') !== -1;
  },

  syncCatalogVisibility: function (hasAccess) {
    const loader = document.querySelector('#catalogo-loader-overlay');
    const exclusive = document.querySelector('[data-exclusive]');
    const exclusiveProducts = document.querySelectorAll('.product-block.-catalog, [data-search-filtered] .product-block.-pronta-entrega');

    if (hasAccess) {
      if (loader) loader.classList.add('-hidden');
      if (exclusive) exclusive.classList.remove('-hidden');

      if (exclusiveProducts.length > 0) {
        exclusiveProducts.forEach(product => {
          product.classList.remove('-hidden');
        });
      }

      return;
    }

    if (loader) loader.classList.remove('-hidden');
    if (exclusive) exclusive.classList.add('-hidden');

    if (exclusiveProducts.length > 0) {
      exclusiveProducts.forEach(product => {
        product.classList.add('-hidden');
      });
    }
  },

  getClient: async function () {
    try {
      const response = await fetch('/conta/cliente', {
        cache: 'no-store',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const client = await response.json();
      const access = Object.keys(client).length > 0;
      return access ? client : null;
    } catch (error) {
      console.error(`getClient error`, error);
    }
  },

  checkClientAccess: function (client) {
    const catalogoContainer = document.querySelector('[data-catalogo]');

    if (!client && catalogoContainer) {
      window.location.href = '/';
      return;
    }

    // Acesso valida tag-only em paginas de catalogo, para não ser executado globalmente.
    if (!client || !catalogoContainer) return;

    const hasAccess = this.hasCatalogAccess(client);
    this.syncCatalogVisibility(hasAccess);

    if (!hasAccess) {
      window.location.href = '/';
    }
  },

  checkProductAccess: function (client) {
    const catalogProduct = document.querySelector('[data-product-catalog]');

    if (!client && catalogProduct) {
      window.location.href = '/entrar';
      return;
    }

    if (!catalogProduct) return;

    if (this.hasCatalogAccess(client)) {
      catalogProduct.classList.add('-has-access');
    } else {
      window.location.href = '/entrar';
    }
  },

  init: async function () {
    const client = await Client.getClient();
    Client.checkClientAccess(client);
    Client.checkProductAccess(client);
  },
};

window.Client = Client;

window.addEventListener('DOMContentLoaded', () => {
  Client.init()
});
